module.exports = __webpack_public_path__ + "img/zdd_invite_feature_2.2dc9b2ae.png";